<div fxLayout="column" fxLayoutAlign="space-evenly stretch" style="margin:5px">
  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign=" stretch" style="margin-bottom: 4px">
    <div>Chain
      <kendo-dropdownlist
        [data]="chainList"
        textField="display"
        valueField="chn"
        [(ngModel)]="selectedChain"
        (valueChange)="chainValueChange($event)"
        name="selectedChain"
        style="width:300px; height: 30px ">
      </kendo-dropdownlist>
    </div>

    <div>DC
      <kendo-dropdownlist
        [data]="divisionList"
        textField="display"
        valueField="divId"
        [(ngModel)]="selectedDivision"
        (valueChange)="divisionValueChange($event)"
        name="selectedDivision"
      style="width:300px; height: 30px ">
      </kendo-dropdownlist>
    </div>
  </div>


  <form novalidate #myForm="ngForm">
    <kendo-grid
      [kendoGridBinding]="gridData"
      [kendoGridSelectBy]="selectedCallback"
      [selectedKeys]="mySelection"
      (dataStateChange)="onStateChange($event)"
      (edit)="editHandler($event)" (cancel)="cancelHandler($event)"
      (save)="saveHandler($event)" (remove)="removeHandler($event)"
      (add)="addHandler($event, myForm)"
      [filterable]="true"
      [resizable]="true"
      [sortable]="true"
      [scrollable]="true"
      [pageSize]="gridState.take" [skip]="gridState.skip" [sort]="gridState.sort"
      [pageable]="{
                  buttonCount: 5,
                  info: true,
                  type: 'numeric',
                  pageSizes: [20, 40, 60],
                  previousNext: true
                 }"
      style="height: 70vh">
      <kendo-grid-column field="itemNum" title="Item Number" filterable="true" [width]="155">
      </kendo-grid-column>

      <kendo-grid-column field="itemDesc" title="Item Description" filterable="true" [width]="155">
      </kendo-grid-column>

      <kendo-grid-column field="catCd" title="GL Code" filterable="true" [width]="150">
        <ng-template kendoGridEditTemplate let-dataItem="dataItem">
          <div *ngIf="uname.errors">
            <b>GL Code must be at less than 12 characters long</b>
          </div>
          <input id="apExportGlCode" [(ngModel)]="dataItem.catCd" kendoGridFocusable name="exportedGLCode"
                 maxlength="12" #uname="ngModel" (click)="handleEvent($event)" class="k-textbox"/>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-command-column  title="Item Details" width="150">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <app-mcl-button *ngIf="!dataItem.removable" text="Item Details.." primary="true" (click)="goToItemDetails(dataItem)">
          </app-mcl-button>
<!--          <app-mcl-button text="Item Details.." primary="true" (click)="goToItemDetails(dataItem)">-->
<!--          </app-mcl-button>-->
        </ng-template>
      </kendo-grid-command-column>

      <kendo-grid-command-column title="Actions" width="100">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <button kendoGridEditCommand  type="button" [primary]="true" style="margin-right: 8px; min-width: 60px;">Edit</button>

          <button *ngIf="dataItem.removable" kendoGridRemoveCommand type="button">Delete</button>
          <button
            kendoGridSaveCommand type="button" [primary]="true"
            [disabled]="myForm.invalid || myForm.pristine" style="margin-right: 8px;">Update
          </button>
          <button kendoGridCancelCommand type="button">Cancel</button>
        </ng-template>
      </kendo-grid-command-column>

    </kendo-grid>
  </form>


  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="end stretch" style="margin-top: 10px">
<!--    <app-mcl-button text="Add" primary="true" (click)="add()">-->
<!--    </app-mcl-button>-->

    <!--    <app-mcl-button text="Update" primary="true" (click)="update()">-->
    <!--    </app-mcl-button>-->

    <!--    <app-mcl-button text="Delete" primary="true" (click)="delete()">-->
    <!--    </app-mcl-button>-->
  </div>
</div>

<div kendoDialogContainer></div>
